// Business-day arithmetic for the pace projection. Extracted from App.js
// 2026-10-30 so it can be tested; behaviour unchanged except:
//   - the live day accrues continuously (no quarter-hour rounding), so the
//     projection converges on the actual total as the day closes;
//   - the clock is a parameter (`now`), fed by App's one-minute ticker.

export function bizDaysInMonth(year,month){
  const days=new Date(year,month+1,0).getDate(); let c=0;
  for(let d=1;d<=days;d++){const dow=new Date(year,month,d).getDay();if(dow!==0&&dow!==6)c++;}
  return c;
}

// The business day as the tracker sees it, Pacific. Elapsed fraction of the
// live day is (now - 6:30am) / 9h, clamped to [0, 1].
export const BIZ_START = 6.5;
export const BIZ_END   = 15.5;

// Business days elapsed in (year, month) up through `upToDate` ("YYYY-MM-DD").
// Three branches keyed off Pacific time, so a closed month renders 21/21 even
// when "today" happens to share a day-of-month with some day in the past month:
//   - Closed: upToDate is after the month's last day -> bizDaysInMonth (full).
//   - Future: upToDate is before the month's first day -> 0.
//   - Current: integer days through upToDate.day, with fractional accrual on
//     the live day only (Pacific 6:30am-3:30pm window, continuous).
// Fractional fires only when upToDate equals real-now in Pacific; test-mode
// dates that aren't "now" get integer accrual.
export function bizDaysElapsedTo(year,month,upToDate,now=new Date()){
  const [uy,um,ud]=upToDate.split("-").map(Number);
  const upY=uy, upMIdx=um-1, upD=ud;
  const today=getPacificParts(now);
  const isLive=upY===today.year&&upMIdx===(today.month-1)&&upD===today.day;

  const lastDay=new Date(year,month+1,0).getDate();
  const upKey=upY*10000+(upMIdx+1)*100+upD;
  const monthEndKey=year*10000+(month+1)*100+lastDay;
  const monthStartKey=year*10000+(month+1)*100+1;
  if(upKey>monthEndKey)return bizDaysInMonth(year,month);
  if(upKey<monthStartKey)return 0;

  let c=0;
  for(let d=1;d<=upD;d++){
    const dow=new Date(year,month,d).getDay();
    if(dow!==0&&dow!==6){
      if(isLive&&d===upD){
        const nowHour=today.hour+(today.minute/60);
        c+=Math.min(1,Math.max(0,(nowHour-BIZ_START)/(BIZ_END-BIZ_START)));
      } else {c+=1;}
    }
  }
  return c;
}

// Date+time parts for America/Los_Angeles.
export function getPacificParts(date=new Date()){
  const parts=Object.fromEntries(
    new Intl.DateTimeFormat("en-US",{timeZone:"America/Los_Angeles",hour12:false,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit"})
      .formatToParts(date).map(p=>[p.type,p.value])
  );
  let hour=parseInt(parts.hour);
  if(hour===24)hour=0;
  return {year:parseInt(parts.year),month:parseInt(parts.month),day:parseInt(parts.day),hour,minute:parseInt(parts.minute)};
}
